import api from "@/services/api";

const { get, post, put } = api.getPrefixedMethods("requirements");

export const mainServices = {
  availableSearchOptions() {
    return get("");
  },
  sendMissingPlanDetails(missingPlanDetails) {
    return post(`add-missing-plan/`, missingPlanDetails);
  },
  searchPriorAuthForms(searchTerm) {
    return post(`search-form/`, searchTerm);
  },
  getPriorAuthForm(id, medicationDetails) {
    return post(`form/${id}`, medicationDetails);
  },
  getInsuranceProviders() {
    return get(`insurance-providers/`);
  },
  fetchDiagnosisRequirements(medication) {
    return post(`diagnosis-requirements/`, medication);
  },
  searchPharmacies(searchTerm) {
    return post("search-pharmacies/", searchTerm);
  },
  getNearestPharmacies(zipCode) {
    return post("get-pharmacies-nearby/", zipCode);
  },
  getMedicationSearchBox() {
    return get("get-medications/");
  },
  searchMedications(searchTerm) {
    return get("search-medications/", { params: { q: searchTerm } });
  },
  getClientConfig(clientCompanyId) {
    return get(`client-config/${clientCompanyId}/`);
  },
  getCurrentUserClientConfig() {
    return get("client-config/");
  },
  getClientMedications(clientCompanyId, searchTerm, pageSize = null) {
    return get(`client/${clientCompanyId}/medications/`, { params: { q: searchTerm, page_size: pageSize } });
  },
  getProductTypeOptions(clientCompanyId) {
    return get(`client/${clientCompanyId}/medications/`, { params: { grouped: 1 } });
  },
  getReferralSources(clientCompanyId, referralSource) {
    return get(`client/${clientCompanyId}/referral-sources/`, { params: { referral_source: referralSource } });
  },
  getClientProviders(clientCompanyId, params) {
    return get(`client/${clientCompanyId}/providers/`, { params });
  },
  getPayorNamesByBinPcn(clientCompanyId, bin, pcn) {
    return get(`client/${clientCompanyId}/payor-names/`, { params: { bin, pcn } });
  },
  getPayorNamesByName(clientCompanyId, payorName) {
    return get(`client/${clientCompanyId}/payor-names/`, { params: { q: payorName } });
  },
  getPayorNamesCount(clientCompanyId) {
    return get(`client/${clientCompanyId}/payor-names/`, { params: { count_only: true } });
  },
  createPayorName(clientCompanyId, payor) {
    return post(`client/${clientCompanyId}/payor-names/`, payor);
  },
  getFaxForms() {
    return get("fax-destinations");
  },
  getFaxFormTemplates() {
    return get("fax-form-templates");
  },
  getFaxFormTemplate(faxFormInput) {
    return get(`fax-form-templates/${faxFormInput}`);
  },
  saveFaxFormTemplate(template) {
    return post("fax-form-templates", template);
  },
  updateFaxFormTemplate(faxFormInput, template) {
    return put(`fax-form-templates/${faxFormInput}`, template);
  },
  reprocessFaxFormTemplate(faxFormInput) {
    return post(`fax-form-templates/${faxFormInput}/reprocess`);
  },
  startFaxFormDetection(pdfUrl) {
    return post("fax-form-templates/detect", { pdfUrl });
  },
  redetectFaxFormTemplate(faxFormInput) {
    return post(`fax-form-templates/${faxFormInput}/detect`);
  },
  getFaxFormTemplateCompanies() {
    return get("fax-form-templates/companies");
  },
  getFaxFormDetection(runId) {
    return get("fax-form-templates/detect", { params: { runId } });
  },
  searchProviders(searchTerm, page = 1) {
    return get("providers", { params: { q: searchTerm, page } });
  },
  getProvidersCount() {
    return get("providers", { params: { count_only: true } });
  },
  // Address book actions take the provider fields themselves, not an order key — they work the same
  // on Create Submission (no order exists yet) as on a saved order's form.
  reconcileProviderAddressBook(providerFields) {
    return post("providers/reconcile/", providerFields);
  },
  addProviderToAddressBook(providerFields) {
    return post("providers/", providerFields);
  },
  applyProviderAddressBookField(providerFields, field) {
    return post("providers/apply-field/", { ...providerFields, field });
  },
  getClientUsers(clientCompanyId, searchTerm) {
    return get(`client/${clientCompanyId}/users/`, { params: { q: searchTerm } });
  },
  getEmailTemplates(clientCompanyId) {
    return get(`client/${clientCompanyId}/email-templates/`);
  },
  getClientCompanyData(clientCompanyId, category, query = "") {
    return get(`client/${clientCompanyId}/data/`, { params: { category, q: query } });
  },
};
